import { useMemo } from "react";
import { unstable_batchedUpdates } from "react-dom";

import { useCategoryStore, useDisclosureStore, useTopicStore } from "~/stores";
import { NormalizedTopic } from "~/types/search.types";
import { SearchActions } from "~/types/actions.enum";

const useTopicsList = () => {
    // Store states
    const activeDisclosure = useDisclosureStore(state => state.disclosure);
    const activeCategory = useCategoryStore(state => state.category);
    const selectedTopicIds = useTopicStore(state => state.selectedTopicIds);

    // Store dispatch methods
    const dispatchCategory = useCategoryStore(state => state.dispatch);
    const dispatchDisclosure = useDisclosureStore(state => state.dispatch);
    const dispatchTopic = useTopicStore(state => state.dispatch);

    // Store methods
    const getTopicsByParentIDs = useTopicStore(state => state.getTopicsByParentIDs);
    const getUniqueTopicId = useTopicStore(state => state.getUniqueTopicId);

    // Topics list
    const filteredTopics = useMemo(() => {
        // Parent IDs
        const disclosureId = activeDisclosure?.exploreId || -1;
        const categoryId = activeCategory?.exploreId || -1;

        return getTopicsByParentIDs({ disclosureId, categoryId }) ?? [];
    }, [activeDisclosure, activeCategory, selectedTopicIds]);

    const handleTopicBtnClick = (isSelected: boolean, topicItem: NormalizedTopic) => {
        const { categoryId, exploreId, disclosureId, count } = topicItem;

        if (count === -1) {
            return;
        }

        const categoryItemParams = {
            categoryId,
            disclosureId,
            value: exploreId,
            isSelected,
        };

        const disclosureItemParams = {
            disclosureId: disclosureId,
            value: categoryId,
            isSelected,
        };

        unstable_batchedUpdates(() => {
            // Increment/decrement the Disclosures and Categories counts from a selected Topic
            dispatchCategory({ type: SearchActions.SET_CATEGORY_TOPIC, payload: categoryItemParams });
            dispatchDisclosure({ type: SearchActions.SET_DISCLOSURE_CATEGORY, payload: disclosureItemParams });

            // Toggle the checkbox of a selected Topic
            if (isSelected) {
                dispatchTopic({ type: SearchActions.SET_SELECTED_TOPIC, payload: exploreId });
            } else {
                dispatchTopic({ type: SearchActions.REMOVE_SELECTED_TOPIC, payload: exploreId });
            }
        });
    }

    return {
        filteredTopics,
        getUniqueTopicId,
        handleTopicBtnClick,
    }

}

export default  useTopicsList;
